import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import PropTypes from "prop-types";
import theme from "~/styles/theme";
import { omitNonReactProps } from "~/services/utils";
var OnAirBasic = function(_param) /*#__PURE__*/ {
    var fill = _param.fill, size = _param.size, otherProps = _object_without_properties(_param, [
        "fill",
        "size"
    ]);
    return _jsxs("svg", _object_spread_props(_object_spread({
        focusable: "false",
        "aria-hidden": "true",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, omitNonReactProps(otherProps)), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.36099 2.95433C9.30393 2.978 9.24855 3.004 9.1949 3.03218C7.65074 3.72094 6.35262 4.98316 5.65442 6.67096L4.31124 9.91791L6.47561 9.91791L7.50253 7.43548C8.01464 6.19753 8.97991 5.28426 10.1267 4.80833C10.1276 4.80795 10.1282 4.80665 10.1291 4.80627L10.1272 4.80174C10.2018 4.7708 10.2773 4.74165 10.3525 4.71469C10.926 4.5091 11.5153 4.41833 12.0939 4.43145C13.9569 4.47372 15.7092 5.59322 16.469 7.4252L18.9231 13.3421C19.0463 13.597 19.157 13.8634 19.254 14.1401L20.6879 17.5973C20.0293 17.8705 19.3449 17.9878 18.6758 17.9664C16.8298 17.9071 15.0997 16.7909 14.3461 14.9739L14.1205 14.4298L9.86092 14.4297L9.63236 14.9822C8.88041 16.7999 7.1514 17.9177 5.30544 17.9787C4.63699 18.0007 3.95319 17.8843 3.2949 17.6123L3.29297 17.6115L4.92725 13.6608C4.33569 13.1745 3.86566 12.4853 3.58428 11.6752L1.44486 16.847C1.2421 17.3371 1.24235 17.8877 1.44556 18.3777C1.64877 18.8676 2.0383 19.2568 2.52845 19.4596C6.02576 20.9063 10.0337 19.244 11.4805 15.7467L11.9903 14.5143L12.4987 15.7401C13.9487 19.2361 17.9582 20.8947 21.4541 19.4447C21.9441 19.2415 22.3333 18.852 22.536 18.3618C22.7388 17.8717 22.7385 17.3211 22.5353 16.8311L18.3164 6.65898C16.8665 3.163 12.857 1.50436 9.36099 2.95433ZM11.7273 9.91791H12.2491L11.9879 9.28803L11.7273 9.91791Z",
                fill: fill
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.9584 15.618C20.5813 16.1287 19.9842 16.4301 19.3494 16.43L6.99474 16.4297C3.49392 16.4296 1.29297 13.126 1.29297 9.91797C1.29297 9.38754 1.50368 8.87883 1.87876 8.50376C2.25383 8.12868 2.76254 7.91797 3.29297 7.91797L14.005 7.91797C17.468 7.91797 20.2327 10.5035 21.2608 13.8413C21.4477 14.448 21.3355 15.1073 20.9584 15.618ZM19.3494 14.43C19.1212 13.6891 18.7966 13.0164 18.3968 12.43C17.3322 10.8682 15.7345 9.91797 14.005 9.91797H3.29297C3.29297 10.6362 3.43067 11.3152 3.67566 11.918C4.28059 13.4063 5.53964 14.4296 6.99481 14.4297L19.3494 14.43Z",
                fill: fill
            })
        ]
    }));
};
OnAirBasic.propTypes = {
    size: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};
OnAirBasic.defaultProps = {
    size: 24,
    fill: theme.colors.icon
};
export default OnAirBasic;
